import { useRef } from "react";
import { globalVariables } from "helper/globalVariables";
import { Location, Mail, Phone, User } from "helper/images";
import { DetailCard } from "./Components/DetailCard";
// import SearchBar from "shared/Components/search";
import { useEffect, useState } from "react";
import { globalClasses } from "../../helper/globalClasses";
import { Card } from "shared/Components/card";
import { useSelector, useDispatch } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { useQuery } from "@apollo/client";
import {
  GetMyRegisteredUnpaidDogs,
  getDogsQuery,
} from "redux/features/dogSlice/dogGql";
import Loader from "shared/Components/loader";
import PageInfo from "shared/Components/pageInfo";
import { useNavigate } from "react-router-dom";
import Table from "./Components/index";
import { CardComponent } from "./Components/CardComponent";
import moment from "moment";
import { setMemberDetails } from "redux/features/memberSlice/memberSlice";
import { setHostProfile } from "redux/features/hostSlice/profile/hostProfileSlice";
import { setDogsAction } from "redux/features/dogSlice/dogReducerSlice";
import { DEFAULT_DATE_FORMAT } from "helper/utility";
import { Button } from "shared/Components/button";
import { MakePaymentCard } from "./Components/MakePayment";
import dogImg from "../../assets/images/dog.jpg";
import { getMemberProfileQuery } from "redux/features/memberSlice/memberGql";
import { doubleCheck } from "helper/icons";
import { avatar } from "helper/images";
import { ApplyForJudgeModal } from "./Components/ApplyForJudgeModal";
import { ApplyForHostModal } from "./Components/ApplyForHostModal";

const headData = [
  globalVariables.name,
  globalVariables.breed,
  globalVariables.sex,
  globalVariables.dob,
  globalVariables.status,
  globalVariables.paymentStatus,
];

// Column width ratios: Payment Status reduced by 15%, extra space distributed to other columns
const columnWidths = ['22%', '18%', '10%', '20%', '14%', '16%'];

export const MemberDashboard = () => {
  const dispatch = useDispatch();
    
  // const { data : profileData, loading : profileLoading, error, refetch } = useQuery(getMemberProfileQuery, {
  //   fetchPolicy: "no-cache",
  // });

  // useEffect(() => {
  //   if (profileData?.getMyMemberProfile) {
  //     dispatch(setMemberDetails(profileData?.getMyMemberProfile));
  //     dispatch(setHostProfile(profileData?.getMyMemberProfile));
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [profileData?.getMyMemberProfile]);


  const { data: unPadiDogsData, loading: unPaidLoading } = useQuery(
    GetMyRegisteredUnpaidDogs,
    {
      fetchPolicy: "no-cache",
    }
  );

  const { data, loading } = useQuery(getDogsQuery, {
    fetchPolicy: "no-cache",
  });

  useEffect(() => {
    dispatch(setDogsAction(data));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const navigate = useNavigate();
  const [filteredTableData, setFilteredTableData] = useState([]);
  const { tableDataCls, iconCls } = globalClasses;
  const { auth } = useSelector((state) => state);
  const {
    profile,
    phone_number,
    email,
    first_name,
    last_name,
    emergency_contact_name,
    emergency_contact_number,
    dateOfJoining,
    location_address,
    city,
    state,
    zipCode,
    role,
    judgeStatus,
  } = auth?.memberReducer?.memberDetails || {};
  const isZoomOut = useMediaQuery({ query: "(max-width: 1600px)" });
  const isMobile = useMediaQuery({ maxWidth: 767 });

  useEffect(() => {
    if (data) {
      setFilteredTableData(data?.getMyRegisteredDogs ?? []);
    }
  }, [data]);

  const [applied, setApplied] = useState(false);

  const contactDetails = [
    {
      icon: <Location className={iconCls} />,
      value: location_address,
      group: "left",
    },
    {
      icon: null,
      value: `${city}, ${state?.replace(/.*-\s*/, "")} ${zipCode}`,
      group: "left",
    },
    {
      icon: <Phone className={iconCls} />,
      value: phone_number,
      group: "right",
    },
    {
      icon: <User className={iconCls} />,
      value: `Member Since ${moment(dateOfJoining).format("MMM YYYY")}`,
      group: "right",
    },
  ];

  // const onSearch = (event) => {
  //   const value = event.target.value;
  //   const orignal = [...data?.getMyRegisteredDogs];
  //   if (value) {
  //     setFilteredTableData(
  //       orignal.filter((dog) => {
  //         return (
  //           dog.call_name.toLowerCase().includes(value.toLowerCase()) ||
  //           dog.breed_mix.toLowerCase().includes(value.toLowerCase()) ||
  //           dog.breed.toLowerCase().includes(value.toLowerCase())
  //         );
  //       })
  //     );
  //   } else {
  //     setFilteredTableData(orignal);
  //   }
  // };

  const onMakePaymentForUnPaid = (e) => {
    dispatch(setDogsAction(unPadiDogsData?.getMyRegisteredUnpaidDogs));
    navigate("/dashboard/makePayment");
  };

  const renderTableBody = () => {
    return filteredTableData.map((data, index) => (
      <tr key={data.id}>
        <td
          onClick={() =>
            navigate("/dashboard/dogHistory", {
              state: {
                dogId: data?.id,
                newDogId: data?.dog_id,
                isMember: true,
                dogIndex: index,
              },
            })
          }
          className={`${tableDataCls} cursor-pointer`}
        >
          <div className="flex flex-row items-center justify-center">
            <img
              src={data?.dogImage === "" ? dogImg : data?.dogImage}
              alt=""
              className="w-10 h-10 mr-2.5 border rounded-full"
            />
            <p className="text-md text-purple-600 font-semibold">{data.call_name ? data?.call_name : "-"}</p>
          </div>
        </td>
        <td className={tableDataCls}>{data.breed_mix || data.breed || "-"}</td>
        <td className={tableDataCls}>{data.gender ?? "-"}</td>
        <td className={tableDataCls}>
        {data.date_of_birth ?  ( moment(data.date_of_birth).format(DEFAULT_DATE_FORMAT) ?? "-" ) : "-" }
        </td>
        <td className={`capitalize ${tableDataCls}`}>{data.status}</td>
        <td className={`capitalize ${tableDataCls}`}>
          <div className="flex justify-center">
            {data.payment_status == "Unpaid" ? (
              <Button
                width="w-[144px]"
                label={globalVariables.makePayment}
                onClick={onMakePaymentForUnPaid}
              />
            ) : (
              <div className="flex justify-center border rounded-md py-2 border-[#2F62A5] w-[150px]">
                <span className="text-base font-regular text-[#2F62A5]">
                  Paid
                </span>
              </div>
            )}
          </div>
        </td>
      </tr>
    ));
  };

  const onRegisterDog = () => {
    navigate("/dashboard/registerDog");
  };

  const judgeModalRef = useRef();
  
  const hostModalRef = useRef();

  const hostJudgeModal = () => {
    hostModalRef.current.openModal();
  };

  const showJudgeModal = () => {
    judgeModalRef.current.openModal();
  };

  const isHostRole = role?.includes("Host");

  const isJudgeRole = role?.includes("Judge");

  return (
    <>
      <ApplyForHostModal  modalRef={hostModalRef}/>
      <ApplyForJudgeModal 
        modalRef={judgeModalRef}
        setApplied={setApplied}
        applied={applied}
      />
      <div className="App rounded-md min-h-screen lg:ml-[17rem] sm:pt-8 bg-white lg:p-10">    
       <PageInfo title={globalVariables.myDashboard}/>
        <div className="relative min-h-[132px] w-full bg-200 border p-8 rounded-md shadow-100">
          <p className="text-xl md:text-3xl font-bold text-white">{globalVariables.welcome}, {first_name} {last_name}.</p>
          <p className="text-lg text-white mt-2">{globalVariables.everythingYouNeed}</p>
        </div>
        <div className="flex flex-col xl:flex-row gap-5 mt-5">
        <div className="border rounded-md shadow-100 p-4 flex-1">
          <p className="text-2xl font-bold text-gray-700 mb-6">{globalVariables.memberDetails}</p>
          <div className="flex mb-3">
            <img
              src={profile || avatar}
              alt=""
              className="h-10 w-10 mr-3 border rounded-[50px]"
            />
            <div className="flex flex-col mr-6">
              <p className="text-xl font-semibold text-gray-900">
                {first_name} {last_name}
              </p>
              <p className="text-sm text-gray-100">
                {email}
              </p>
            </div>
          </div>
          <div className="p-4 bg-white shadow-md rounded-lg">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-y-5 gap-x-4">
              <div className="last:ml-5">
                {contactDetails
                  .filter((detail) => detail.group === "left")
                  .map((detail, index) => (
                    <div key={index} className="flex items-center space-x-2 mb-2">
                      <span className="text-gray-500 w-5">{detail.icon}</span>
                      <span className="text-gray-900 text-sm">{detail.value}</span>
                    </div>
                  ))}
              </div>
              <div>
                {contactDetails
                  .filter((detail) => detail.group === "right")
                  .map((detail, index) => (
                    <div key={index} className="flex items-center space-x-2 mb-2">
                          <span className="text-gray-500">{detail.icon}</span>
                      <span className="text-gray-900 text-sm">{detail.value}</span>
                    </div>
                  ))}
              </div>
            </div>
          </div>
          <h1 className="text-xl text-purple-50 font-semibold my-4">
            {globalVariables.emergencyContactNumberCap}
          </h1>
          <div className="flex justify-between border rounded-md p-3 mt-2">
            {emergency_contact_number ? (
              <>
                <h1 className="text-lg text-gray-900 font-semibold">
                  {emergency_contact_name}
                </h1>
                <div className="flex items-center gap-2 text-lg text-gray-600 font-medium">
                  <Phone />
                  <span>{emergency_contact_number}</span>
                </div>
              </> 
             ) : (
              <div className="text-sm text-gray-900 font-medium items-center">
                Emergency contact number does not provided
              </div>
             )}
          </div>
        </div>
      </div>
        {loading ? (
          <Loader />
        ) : (
          <>
            {data?.getMyRegisteredDogs?.length > 0 ? (
              <div className="border rounded-md p-2 shadow-100 p-5 mt-5">
                <div className="flex justify-between mb-3 item-center">
                  <p
                    className={
                      !isMobile
                        ? "text-2xl font-bold text-gray-700"
                        : "text-xl font-semibold text-gray-700 mr-auto ml-8 mb-0 md:mb-5"
                    }
                  >
                    {globalVariables.myDogs}
                  </p>
                  <div className="flex flex-col md:flex-row gap-4">
                    {/* <SearchBar
                      onChange={onSearch}
                      placeholder={globalVariables.search}
                    /> */}
                    <Button
                      onClick={onRegisterDog}
                      width="w-[130px]"
                      label={globalVariables.addDog}
                    />
                  </div>
                </div>
                {!isMobile ? (
                    <Table headData={headData} tableBody={renderTableBody()} columnWidths={columnWidths} />
                ) : (
                  <div className="divide-y divide-slate-200">
                    {filteredTableData.map((data, index) => (
                      <CardComponent
                        onClick={() =>
                          navigate("/dashboard/dogHistory", {
                            state: {
                              dogId: data?.id,
                              newDogId: data?.dog_id,
                              isMember: true,
                              dogIndex: index,
                            },
                          })
                        }
                        data={data}
                        key={index}
                      />
                    ))}
                  </div>
                )}
              </div>
            ) : (
              <Card
                title={globalVariables.registerYourDog}
                desc={globalVariables.registeringDog}
                buttonLabel={globalVariables.register}
                onPress={onRegisterDog}
              />
            )}
          </>
        )}
        <div className="relative border rounded-md shadow-100 p-4 mt-5">
          <p className="text-2xl font-bold text-gray-700 mb-4">{globalVariables.joinOurCommunity}</p>
          <div className="border-[5px] rounded-md border-gradient-600 mb-4">
          <div className="absolute right-1 top-12">
            <img src={doubleCheck} />
          </div>
            <div className="border rounded-md py-6 bg-light-300">
              <h1 className="text-xl text-purple-50 font-medium ml-4">
                Join Us as a <span className="font-black">Judge</span> or <span className="font-black">Host a Trial!</span>
              </h1>
            </div>
            <div className="p-8">
              <p className="text-sm text-black">
                {globalVariables.joinCommunityText}
              </p>
              <button className="mt-4">
                <span className="text-sm font-bold text-purple-200">{globalVariables.submitInfoMessage}</span>
              </button>
            </div>
            <div className="flex flex-col md:flex-row gap-2 md:justify-center mb-5 items-center">
              <Button onlyDisabled={isHostRole} width="w-[174px]" label={isHostRole ? "Already a Host" : globalVariables.hostATrail} onClick={hostJudgeModal} />
              <Button onlyDisabled={isJudgeRole || judgeStatus == "active" || applied}  width="w-[174px]" label={applied || judgeStatus == "active" ? "Applied" : isJudgeRole ? "Already a Judge" : globalVariables.judgeApplication} onClick={showJudgeModal} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
